import axios from 'axios'
import getLocalizedTexts from '../localization'
import {
    // Constants
    SHOW_EULA,
    ACCEPT_EULA,
    DECLINE_EULA,
    SET_EULA,
    UDPATE_FROM_HASH,

    // Actions
    setButtonTexts,
    setEula,
    fetchingEula,
    openEulaPrompt,
    eulaInitated,
    eulaPrompted,
    eulaNotOk,
    eulaDeclined,
    eulaAccepted,
    acceptEula,
    openOnFetch,

    // Selectors
    getUserId,
    getEulaHash,
    isEulaOk,
    isEulaBeingFetched,
    shouldOpenOnFetch,
    isOpen,
    showEulaPrompt,
} from '../data'
import { actions, selectors, constants as c, getAttributes } from '../imports'

// todo: probably pass around the user id in the outward actions...?

const getRefreshTokenUrl = (state) => {
    const server = selectors.getActiveServer(state)
    const locale = selectors.getLocale(state)
    const attributes = getAttributes(locale)
    let refreshTokenService = ''
    if (server.sso.slinger !== undefined) {
        refreshTokenService = attributes.slingerRefresh.replace('{host}', server.sso.slinger)
    }

    return refreshTokenService
}

const getEulaUrl = (state) => {
    const server = selectors.getActiveServer(state)
    const locale = selectors.getLocale(state)
    const attributes = getAttributes(locale)
    let eulaUrl = ''
    if (server.sso.slinger !== undefined) {
        eulaUrl = attributes.getEula.replace('{host}', server.sso.slinger)
    }

    return eulaUrl
}

const log = (store, text) => {
    store.dispatch(actions.log(text))
}

const fetchNewestEula = (store, userId = null, newEula = false, showOnFetch = false) => {
    store.dispatch(fetchingEula())

    const state = store.getState()
    const url = getEulaUrl(state)
    const locale = selectors.getLocale(state)

    // The hash has changed...
    // Now we need to get the new EULA, and add it to state
    // const url = 'https://lts-bacchus.ccpgames.com/agreements/eve/EULA' // <== todo: start of url missing
    axios({
        method: 'get',
        url,
        headers: {
            'Accept-Language': locale,
        },
    })
        .then((response) => {
            // console.log('response: ', response)
            store.dispatch(setEula(response.data.DocumentText, response.data.HashCode))
            if (newEula) {
                store.dispatch(openEulaPrompt(userId, true))
            } else if (showOnFetch) {
                // console.log('hello world')
                store.dispatch(showEulaPrompt(userId, response.data.HashCode, false))
            }
        })
        .catch((e) => {
            // TODO: Technically 404 is expected in this case
            // Other errors might be interesting to look into
            console.info(`Couldn't get the newest EULA (${e})`)
            store.dispatch(setEula('', ''))
        })
}

const fetchNewTokens = (store, refreshToken) => {
    const state = store.getState()
    const url = getRefreshTokenUrl(state)

    axios({
        method: 'post',
        url,
        data: {
            token: refreshToken,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            const {
            // HashedUserID,
            // UserName, // this is what we refer to as userId
                AccessToken,
                RefreshToken,
                EndUserLicenseAgreement,
            } = response.data

            // const state = store.getState()
            const userId = getUserId(state)
            const serverId = selectors.getActiveServerId(state)

            store.dispatch(
                actions.setTokens(serverId, userId, AccessToken, RefreshToken),
            )

            if (EndUserLicenseAgreement == null) {
            // No need to accept anything, we are done
            // This only happens if CIS is down, or the server
            // doesn't have a EULA to show
                store.dispatch(eulaNotOk(userId))
                return
            }

            if (EndUserLicenseAgreement.HasAgreed) {
            // No need to accept anything, user has already
            // accepted the newest EULA
                store.dispatch(eulaAccepted(userId))
            }

            // Retry to accept the EULA
            store.dispatch(acceptEula())
        })
}

const EulaMiddleware = store => next => (action) => {
    switch (action.type) {
        // Locale has changed, get the localized text
        case c.LOCALE_CHANGED: {
            const result = next(action)
            const text = getLocalizedTexts(action.payload)
            store.dispatch(setButtonTexts(text.accept, text.decline))
            return result
        }

        case SHOW_EULA: {
            const result = next(action)

            const { userId, hash, accepted } = action.payload

            if (accepted) {
                // console.log('eula already accepted')
                store.dispatch(eulaAccepted(userId))
                return result
            }

            if (hash == null) {
                // console.log('eula not available')
                store.dispatch(eulaNotOk(userId))
                return result
            }

            const state = store.getState()
            store.dispatch(eulaInitated(userId))

            if (isEulaBeingFetched(state)) {
                // console.log('eula is being fetched')
                store.dispatch(openOnFetch())
                return result
            }

            if (hash !== getEulaHash(state)) {
                // console.log('hash mismatch, getting newer eula')
                fetchNewestEula(store, userId, false, true)
                return result
            }

            if (!isEulaOk(state)) {
                // console.log('eula is not ok')
                store.dispatch(eulaNotOk(userId))
            }

            store.dispatch(openEulaPrompt(userId))
            store.dispatch(eulaPrompted(userId))
            log(store, 'EULA prompt opened')

            return result
        }

        case ACCEPT_EULA: {
            const result = next(action)
            // dispatch an action here???
            log(store, 'EULA accepted')

            const state = store.getState()

            const userId = getUserId(state)
            const serverId = selectors.getActiveServerId(state)
            const accessToken = selectors.getAccessToken(state, serverId, userId)
            const refreshToken = selectors.getRefreshToken(state, serverId, userId)

            // 0. Here I should try to call the accept axios

            // const state = store.getState()
            const url = getEulaUrl(state)

            // console.log('trying to put with : ', accessToken)

            // const url = 'https://lts-bacchus.ccpgames.com/agreements/eve/EULA' // <== todo: start of url missing
            axios({
                method: 'put',
                url,
                data: {
                    Token: accessToken,
                    AgreementHash: getEulaHash(state),
                },
            })
                .then((response) => {
                    // 1. TRUE
                    if (response.data.Success) {
                        store.dispatch(eulaAccepted(userId))
                        return
                    }

                    // 2. FALSE
                    // Fetch the newest EULA and reopen the prompt
                    fetchNewestEula(store, userId, true)
                })
                .catch(() => {
                    // 3. ERROR
                    // Get a new token
                    // retry this...
                    // todo: first get a new token
                    // then when we have a new token
                    // retry to accept the eula
                    // this could result in an endless loop
                    // console.log('e', e)
                    fetchNewTokens(store, refreshToken)
                })

            // and depending on the result I should

            // 1. TRUE
            // Everything is a ok, send out a eula accepted action

            // 2. FALSE
            // There is a newer EULA available
            // I need to
            //   a. Get the newest EULA
            //   b. Update the state
            //   c. Show the new EULA <=== This will be tough
            //   d. Nothing more since the new answer will be cought in this middleware

            // 3. ERROR
            // AccessToken was invalid
            // I need to
            //   a. Get a new token
            //   b. Try and call the axios again (step 0)

            return result
        }

        case DECLINE_EULA: {
            const result = next(action)
            log(store, 'EULA declined')
            const userId = getUserId(store.getState())
            store.dispatch(eulaDeclined(userId))
            return result
        }

        case SET_EULA: {
            const result = next(action)
            log(store, 'EULA updated...!')
            const state = store.getState()
            const open = isOpen(state)
            if (!open && shouldOpenOnFetch(state)) {
                const userId = getUserId(state)
                const hash = getEulaHash(state)
                store.dispatch(showEulaPrompt(userId, hash, false))
            }
            return result
        }

        case UDPATE_FROM_HASH: {
            const result = next(action)

            const newHash = action.payload
            const oldHash = getEulaHash(store.getState())
            if (newHash === oldHash) {
                // The hash has not changed, we already have the newest EULA in state
                return result
            }

            fetchNewestEula(store)

            return result
        }

        default:
            return next(action)
    }
}

export default EulaMiddleware



// WEBPACK FOOTER //
// ./src/features/Eula/middleware/index.js